import { render } from "./DocAsyncApi.vue?vue&type=template&id=2098447c&scoped=true"
import script from "./DocAsyncApi.vue?vue&type=script&lang=js"
export * from "./DocAsyncApi.vue?vue&type=script&lang=js"

import "./DocAsyncApi.vue?vue&type=style&index=0&id=2098447c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2098447c"]])

export default __exports__